import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { getProductUnitTypes } from "../../../../api/productUnitType";
import { alertError } from "../../../../utils/logger";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductUnitTypeContent from "./ProductUnitTypeContent";

function getData(productUnitTypes) {
	let data = [];
	for (let i = 0; i < productUnitTypes.length; ++i) {
		const elem = {};
		const productUnitType = productUnitTypes[i];

		elem.descripcion = productUnitType?.descripcion;
		elem.id = productUnitType?.id;

		data = data.concat(elem);
	}
	return data;
}

export default function ProductUnitTypesPage() {
	const [data, setData] = useState([]);
	const [selectedProductUnitType, setSelectedProductUnitType] = useState(
		null
	);

	const [
		openProductUnitTypeInfoDialog,
		setOpenProductUnitTypeInfoDialog,
	] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push(
								"/tipos-unidades-productos/" + cell + "/edit"
							);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getProductUnitTypes(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage:
						"No se han podido obtener los tipos de unidad de productos.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Tipos de unidades productos">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() =>
								history.push("/tipos-unidades-productos/edit")
							}
						>
							Nueva unidad
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(data)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const productUnitType = data?.find(
									(x) => x.id === row.id
								);
								setSelectedProductUnitType(productUnitType);
								setOpenProductUnitTypeInfoDialog(true);
							},
						}}
					/>
					<EntityInfoDialog
						title={
							"Tipo de unidad de producto: " +
							selectedProductUnitType?.descripcion
						}
						open={openProductUnitTypeInfoDialog}
						setOpen={setOpenProductUnitTypeInfoDialog}
						content={
							<ProductUnitTypeContent
								productUnitType={selectedProductUnitType}
							/>
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
